<template>
  <v-autocomplete
    color="primary"
    v-model="materialsSelected"
    :clearable="!unclearable"
    :items="materialsItems"
    :loading="materialsLoading"
    :search-input.sync="materialsSearch"
    item-text="Description"
    item-value="material_id"
    item-disabled="disabled"
    :label="noLabel ? '' : $t('Material.title')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :hint="hint"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  >
    <template v-if="errorHint" v-slot:message="{ key, message }">
      <div :class="key == 0 ? 'danger--text' : ''">
        {{ message }}
      </div>
    </template>
    <template v-slot:item="{ item }">
      <span
        v-if="item.standard_name && item.standard_name.length > 12"
        :title="item.standard_name"
        style="cursor: pointer"
      >
        {{ item.Description }}
      </span>
      <span v-else>
        {{ item.Description }}
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Materials from "@/api/materials";

export default {
  name: "SearcherMaterial",

  props: {
    value: Object,
    materialCategories: Array,
    noLabel: Boolean,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    hint: String,
    errorHint: Boolean,
  },

  computed: {
    materialsItems() {
      var materials;
      if (this.materialCategories && this.materialCategories.length > 0) {
        materials = this.materials.filter((material) =>
          this.materialCategories.find(
            (cat) => cat.code == material.category_code
          )
        );
      } else {
        materials = this.materials;
      }
      return materials.map((material) => {
        const Description = i18n.t("Material.materialNameWithCodeAndStandard", [
          material.material_code,
          material.material_name,
          material.standard_name && material.standard_name.length > 12
            ? material.standard_name.slice(0, 12) + "......"
            : material.standard_name,
        ]);
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.material_id == material.material_id
            )
          : false;
        return Object.assign({}, material, { Description, disabled });
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["accountSettings"]),
  },

  data: () => ({
    materials: [],
    materialsLoading: false,
    materialsSearch: "",
    materialsSelected: null,
  }),

  mounted() {
    this.materialsLoading = true;
    Materials.fetch({})
      .then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materials = response.data.materials;
            if (this.$route.query.material_id) {
              let res = this.materials.filter((v) => {
                return v.material_id == this.$route.query.material_id;
              });
              this.materialsSelected = res[0];
            }
          }
          this.materialsLoading = false;
        }.bind(this)
      )
      .catch(
        function () {
          this.materialsLoading = false;
        }.bind(this)
      );
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.materialsSelected = this.value;
      },
    },
    materialsSelected: {
      handler() {
        this.$emit("input", this.materialsSelected);
      },
    },
  },
};
</script>
